import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { DataService,GUEST_VEHICLE_ID } from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { ExtendparkingPage } from '../extendparking/extendparking.page';
import { PlatformService } from 'src/app/platform.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { DownloadFileOptions, Directory, Filesystem } from '@capacitor/filesystem';
import { Browser } from '@capacitor/browser';
import { FileOpener } from '@ionic-native/file-opener/ngx';

@Component({
  selector: 'app-permit-info',
  templateUrl: './permit-info.page.html',
  styleUrls: ['./permit-info.page.scss'],
})
export class PermitInfoPage implements OnInit,AfterViewInit {
  guestVehicleID= GUEST_VEHICLE_ID
  expireDistance
  startDistance
  startDays
  startHours
  startMinutes
  startSeconds
  expireDays
  expireHours
  expireMinutes
  expireSeconds
  toggleChecked:boolean;
  @Input() permit: any;
  @Input() type: any;
  now: any;
 
  difference: number;
  constructor(
    private fileOpener: FileOpener,
    private errorHandlerSRV:ErrorHandlerService,
    public platformSRV:PlatformService,
    private changeDetectorRef: ChangeDetectorRef,
    private loaderSRV:LoaderService,
    private toasterSRV:ToastService,
    public modalController: ModalController,
    public dataService: DataService,
    public translateService: TranslateService,
    private alertCtrl: AlertController,
    
  ) {}
  
  async download(link,name){
    if(this.platformSRV.isNative.value){
      this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.downloading') || 'downloading...')
      const options:DownloadFileOptions = {
        url: link,
        path: name,
        directory: Directory.Data,
        method: 'GET',
        
      };
      try{
      const response = await Filesystem.downloadFile(options);
      
      if(response.path){
        const read = await Filesystem.readFile({
          path: name,
          directory: Directory.Data,
        });
        
        const pdfPath = await Filesystem.writeFile({
          path:name,
          data:read.data,
          directory:Directory.External
        })
        
        this.fileOpener.showOpenWithDialog(pdfPath.uri,'application/pdf').then(()=>{
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss("refresh")
        }).catch(err=>{
          this.errorHandlerSRV.displayErrorMessage(err,true)

        })
      }
    } catch(err){
      this.loaderSRV.dismissLoader()
      this.errorHandlerSRV.displayErrorMessage(err,true)

    }
     
    } else {
      await Browser.open({ url: link });
      this.modalController.dismiss("refresh")
    }
  }
  async downloadPermit(id){
    var link = `${this.dataService.apiUrl}/permits/standard/${id}/pdf`
    var name =  new Date().toLocaleString().replace(/[,:\s\/]/g, '-') +`.pdf`
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant('keys.data.permits.print_permit') || 'Print Permit',
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
          role: 'cancel',
          handler: () => {
            
          },
        },
        {
          text: this.translateService.instant('keys.data.common.confirm') || 'Confirm',
          role: 'confirm',
          handler: async () => {
            this.download(link,name)
            
            
          },
        },
      ],
    });

    await alert.present();
  }
  async downloadTempPermit(id){
    var link = `${this.dataService.apiUrl}/permits/temporary/${id}/pdf`
    var name = new Date().toLocaleString().replace(/[,:\s\/]/g, '-') +`.pdf`
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant('keys.data.permits.print_permit') || 'Print Permit',
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
          role: 'cancel',
          handler: () => {
            
          },
        },
        {
          text: this.translateService.instant('keys.data.common.confirm') || 'Confirm',
          role: 'confirm',
          handler: async () => {
           
            this.download(link,name)
           
          },
        },
      ],
    });

    await alert.present();
  }
  ngOnInit() {
    if(this.type=='standard'){
      if(this.permit['prevent_rollover']!='1'){
        this.toggleChecked=true
      } else{
        this.toggleChecked=false
      }
    }
  // if(this.type=='standard'){
  //   this.permit = res['permit'];
  //   // this.dataService
  //   // .getData(`permits/standard/${this.permitId}/info`).pipe(map(
  //   //   data=>{
        
        
  //   //     if(data['permit']['prevent_rollover']=='0'){
  //   //       this.toggleChecked=true
  //   //     } else{
  //   //       this.toggleChecked=false
  //   //     }
  //   //     return data
  //   //   }
  //   // ))
  //   // .subscribe((res) => {
  
  //   //   if (res['permit']) {
  //   //     this.permit = res['permit'];
  //   //   }
  //   // });
  // } else {
  //   this.dataService
  //   .getData(`permits/temporary/${this.permitId}/info`)
  //   .subscribe((res) => {
  
     
  //     if (res['permit']) {
  //       this.permit = res['permit'];
  //     }
  //   });
  // }
    
  }
  async openExtendParkingPage(lotId){
   
    const desktopModal = await this.modalController.create({
      component: ExtendparkingPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        lotId,
        permit:this.permit
      }
    });
    const mobileModal = await this.modalController.create({
      component: ExtendparkingPage,
      breakpoints: [0.5, 0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        lotId,
        permit:this.permit
      }
    });
    const tabletModal = await this.modalController.create({
      component: ExtendparkingPage,
      breakpoints: [0.5, 0.85,1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        lotId,
        permit:this.permit
      }
    });
    if(this.platformSRV.device=='desktop'){
      return await desktopModal.present();
    } else if(this.platformSRV.device=='mobile'){
      return await mobileModal.present();
    } else if(this.platformSRV.device=='tablet'){
      return await tabletModal.present();
    }
  }
  ngAfterViewInit() {
    var countDownExpiryTime = new Date(this.permit['endTime']).getTime();
    var countDownStartTime = new Date(this.permit['startTime']).getTime();

 setInterval(()=> {
  var now = new Date().getTime();

  this.expireDistance = countDownExpiryTime - now;
  this.expireDays =  Math.floor(this.expireDistance / (1000 * 60 * 60 * 24));

  this.expireHours = Math.floor((this.expireDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  this.expireHours = ("0" + this.expireHours).slice(-2)

  this.expireMinutes = Math.floor((this.expireDistance % (1000 * 60 * 60)) / (1000 * 60));
  this.expireMinutes = ("0" + this.expireMinutes).slice(-2)

  this.expireSeconds = Math.floor((this.expireDistance % (1000 * 60)) / 1000);
  this.expireSeconds = ("0" + this.expireSeconds).slice(-2)

  this.startDistance = countDownStartTime - now;
  this.startDays =  Math.floor(this.startDistance / (1000 * 60 * 60 * 24));
  
  this.startHours = Math.floor((this.startDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  this.startHours = ("0" + this.startHours).slice(-2)

  this.startMinutes = Math.floor((this.startDistance % (1000 * 60 * 60)) / (1000 * 60));
  this.startMinutes = ("0" + this.startMinutes).slice(-2)

  this.startSeconds = Math.floor((this.startDistance % (1000 * 60)) / 1000);
  this.startSeconds = ("0" + this.startSeconds).slice(-2)
  
  this.changeDetectorRef.detectChanges()
}, 1000);
  }
  
  getChecked(e,PermitJoinID){
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
    if(e.target.checked==true){
      this.dataService.postData(`permits/standard/${PermitJoinID}/update`,{prevent_rollover:"0"}).subscribe({
       next:d=>{
        if(d['status']=="success"){
          this.modalController.dismiss("refresh")
          
          this.loaderSRV.dismissLoader()
         } else {
          this.toasterSRV.presentErrorToast(d['message'])
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss()
         }
       },
       error:err=>{
        this.modalController.dismiss()
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
        
      }
      
      
      )
      
    } else {
      this.dataService.postData(`permits/standard/${PermitJoinID}/update`,{prevent_rollover:"1"}).subscribe({
       next:d=>{
        if(d['status']=="success"){
          this.loaderSRV.dismissLoader()
          this.modalController.dismiss("refresh")
         
         } else {
          this.toasterSRV.presentErrorToast(d['message'])
      
        this.loaderSRV.dismissLoader()
        this.modalController.dismiss()
         }
       },
       error:err=>{
        this.modalController.dismiss()
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
       
      })
      
    }
  
   
  }
  onCloseModal() {
   
    this.modalController.dismiss();
  }
}
